module.exports = __webpack_public_path__ + "static/img/C4D0014.5347e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0014.jpg
// module id = 7bKE
// module chunks = 0